// PHA-1168: plain-language filter chips for the builder, so an admin can check
// what the AI understood before saving ("APCM tier = 2", not JSON).
import type { CustomViewField } from '../../services/api';

const OP_TEXT: Record<string, string> = {
  eq: 'is', ne: 'is not', gt: '>', gte: '≥', lt: '<', lte: '≤',
  contains: 'contains', in: 'is one of', exists: 'is set', empty: 'is empty',
};

export const describeFilter = (
  filter: { field: string; op: string; value?: unknown; include_empty?: boolean },
  fields: Map<string, CustomViewField>,
): string => {
  const label = fields.get(filter.field)?.label || filter.field;
  const op = OP_TEXT[filter.op] || filter.op;
  let value = '';
  if (filter.op !== 'exists' && filter.op !== 'empty') {
    if (Array.isArray(filter.value)) value = ` ${filter.value.join(', ')}`;
    else if (typeof filter.value === 'boolean') value = filter.value ? ' yes' : ' no';
    else if (filter.value !== undefined && filter.value !== null) value = ` ${String(filter.value)}`;
  }
  return `${label} ${op}${value}${filter.include_empty ? ' (or empty)' : ''}`;
};
